import React, { useState, useCallback } from 'react';
import { Col, Divider, Layout, Menu, Row } from 'antd';
import Filter from './Filter';
// import Filter from 'components/Filter/Filter';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Content, Sider } = Layout;

const MobileViewFilter = (props) => {
    const [selected, setSelected] = useState('0');

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;   

    // Handle filter menu click
    const handleClick = useCallback((e) => {
        setSelected(e.key);
    }, []);

    return (
        // <Row>
        <Content>
            <Layout>
                <Row style={{ width : '325px', backgroundColor : '#ffffff'}}>
                    <Col span={11}>
                        <Filter page={selected} payload = {props}/>
                        {/* <div style={{ width: 10 }}>
                        </div> */}
                    </Col>
                    <Col span={2} style={{
                        display : 'flex',
                        justifyContent : 'center'
                    }}>
                        <Divider type='vertical' style={{
                            height : '220px'
                        }}/>
                    </Col>
                    <Col span={11}>
                        <Sider width={160}>
                            <Menu
                                // mode="inline"
                                onClick={handleClick}
                                selectedKeys={[selected]}
                            // style={{ height: '10%', borderRight: 0 }}
                            >
                                <Menu.Item key="1">{langdata.Date ? langdata.Date : 'Date'}</Menu.Item>
                                <Menu.Item key="2">{langdata.Consultation ? langdata.Consultation : 'Consultation'}</Menu.Item>
                                <Menu.Item key="3">{langdata.Fee ? langdata.Fee : 'Fee'}</Menu.Item>
                                <Menu.Item key="4">{langdata.Gender ? langdata.Gender : 'Gender'}</Menu.Item>
                            </Menu>
                        </Sider>
                    </Col>
                </Row>
            </Layout>
        </Content>

    // </Row>
    );
};

export default MobileViewFilter;
